function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Form from "semantic-ui-react/dist/es/collections/Form/Form.js";
import { debounce } from 'debounce';
import isEqual from 'fast-deep-equal';
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { ShowOn } from "../../layout/ShowOn";
import { CHECK_OUR_AVAILABILITY, SEARCH } from "../../../utils/default-strings";
import { ICON_NAMES } from "../../elements/Icon";
import { Button } from "../../elements/Button";
import { CHECK_IN, CHECK_OUT, GUESTS, LOCATION } from "../../../utils/default-strings";
import { getWillLocationDropdownOpenAbove } from "./utils/getWillLocationDropdownOpenAbove";
import { SearchFields } from "./components/SearchFields";
import { SearchModal } from "./components/SearchModal";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dates: _this.props.datesInputValue,
      guests: _this.props.guestsInputValue,
      location: _this.props.locationInputValue,
      willLocationDropdownOpenAbove: _this.props.willLocationDropdownOpenAbove
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.isDisplayedAsModal) return;
      global.document.addEventListener('scroll', _this.handleScroll);

      _this.handleScroll();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      if (_this.props.isDisplayedAsModal) return;
      global.document.removeEventListener('scroll', _this.handleScroll);
    });

    _defineProperty(_assertThisInitialized(_this), "createRef", function (container) {
      _this.container = container;
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", debounce(function () {
      _this.setState({
        willLocationDropdownOpenAbove: getWillLocationDropdownOpenAbove(_this.container, _this.props.willLocationDropdownOpenAbove)
      });
    }, 100));

    _defineProperty(_assertThisInitialized(_this), "persistInputChange", function (name, value) {
      var onChangeInput = _this.props.onChangeInput;

      _this.setState(_defineProperty({}, name, value), function () {
        onChangeInput(_this.state);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function () {
      _this.props.onSubmit(_this.state);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          isDisplayedAsModal = _this$props.isDisplayedAsModal,
          isFixed = _this$props.isFixed,
          isStackable = _this$props.isStackable,
          summaryElement = _this$props.summaryElement;
      var _this$state = _this.state,
          dates = _this$state.dates,
          location = _this$state.location,
          guests = _this$state.guests,
          willLocationDropdownOpenAbove = _this$state.willLocationDropdownOpenAbove;
      return isDisplayedAsModal ? React.createElement(SearchModal, _extends({}, _this.props, {
        datesInputValue: dates,
        guestsInputValue: guests,
        locationInputValue: location,
        onInputChange: _this.persistInputChange,
        onSubmit: _this.handleSubmit,
        willLocationDropdownOpenAbove: willLocationDropdownOpenAbove
      })) : React.createElement("div", {
        className: classnames(className, 'search-bar', {
          'is-fixed': isFixed,
          'is-stackable': isStackable
        }),
        ref: _this.createRef
      }, isFixed ? React.createElement(HorizontalGutters, null, summaryElement, React.createElement(ShowOn, {
        computer: true,
        widescreen: true
      }, React.createElement(Form, {
        onSubmit: _this.handleSubmit
      }, React.createElement(SearchFields, _extends({}, _this.props, {
        datesInputValue: dates,
        guestsInputValue: guests,
        locationInputValue: location,
        onInputChange: _this.persistInputChange,
        willLocationDropdownOpenAbove: willLocationDropdownOpenAbove
      })))), React.createElement(ShowOn, {
        mobile: true,
        tablet: true
      }, React.createElement(SearchModal, _extends({}, _this.props, {
        datesInputValue: dates,
        guestsInputValue: guests,
        locationInputValue: location,
        onInputChange: _this.persistInputChange,
        onSubmit: _this.handleSubmit,
        willLocationDropdownOpenAbove: willLocationDropdownOpenAbove
      })))) : React.createElement(Form, {
        onSubmit: _this.handleSubmit
      }, React.createElement(SearchFields, _extends({}, _this.props, {
        datesInputValue: dates,
        guestsInputValue: guests,
        locationInputValue: location,
        onInputChange: _this.persistInputChange,
        willLocationDropdownOpenAbove: willLocationDropdownOpenAbove
      }))));
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var previousInputValueProps = {
        dates: previousProps.datesInputValue,
        guests: previousProps.guestsInputValue,
        location: previousProps.locationInputValue
      };
      var currentInputValueProps = {
        dates: this.props.datesInputValue,
        guests: this.props.guestsInputValue,
        location: this.props.locationInputValue
      };

      if (!isEqual(previousInputValueProps, currentInputValueProps)) {
        this.setState(currentInputValueProps);
      }
    }
  }]);

  return Component;
}(PureComponent);
Component.displayName = 'SearchBar';
Component.defaultProps = {
  className: null,
  dateRangePickerLocaleCode: undefined,
  datesCheckInLabel: CHECK_IN,
  datesCheckOutLabel: CHECK_OUT,
  datesInputFocusedInput: undefined,
  datesInputOnFocusChange: Function.prototype,
  datesInputValue: undefined,
  getIsDayBlocked: Function.prototype,
  guestsInputLabel: GUESTS,
  guestsInputValue: undefined,
  guestsPopupId: undefined,
  isCalendarIconDisplayed: undefined,
  isDateRangePickerLoading: undefined,
  isDisplayedAsModal: false,
  isFixed: false,
  isModalOpen: undefined,
  isStackable: false,
  locationInputLabel: LOCATION,
  locationInputValue: undefined,
  locationOptions: null,
  maximumGuestsInputValue: undefined,
  modalHeadingText: CHECK_OUR_AVAILABILITY,
  modalSummaryElement: null,
  onChangeInput: Function.prototype,
  onSubmit: Function.prototype,
  searchButton: React.createElement(Button, {
    icon: ICON_NAMES.SEARCH,
    isFormSubmit: true,
    isRounded: true
  }, SEARCH),
  summaryElement: null,
  willLocationDropdownOpenAbove: false
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  dateRangePickerLocaleCode: PropTypes.string,
  datesCheckInLabel: PropTypes.string,
  datesCheckOutLabel: PropTypes.string,
  datesInputFocusedInput: PropTypes.oneOf([null, 'startDate', 'endDate']),
  datesInputOnFocusChange: PropTypes.func,
  datesInputValue: PropTypes.shape({
    endDate: PropTypes.object,
    startDate: PropTypes.object
  }),
  getIsDayBlocked: PropTypes.func,
  guestsInputLabel: PropTypes.string,
  guestsInputValue: PropTypes.number,
  guestsPopupId: PropTypes.string,
  isCalendarIconDisplayed: PropTypes.bool,
  isDateRangePickerLoading: PropTypes.bool,
  isDisplayedAsModal: PropTypes.bool,
  isFixed: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  isStackable: PropTypes.bool,
  locationInputLabel: PropTypes.string,
  locationInputValue: PropTypes.string,
  locationOptions: PropTypes.arrayOf(PropTypes.shape({
    indent: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  maximumGuestsInputValue: PropTypes.number,
  modalHeadingText: PropTypes.string,
  modalSummaryElement: PropTypes.node,
  onChangeInput: PropTypes.func,
  onSubmit: PropTypes.func,
  searchButton: PropTypes.node,
  summaryElement: PropTypes.node,
  willLocationDropdownOpenAbove: PropTypes.bool
} : {};